import {
  add,
  importAndReset,
  load,
  remove,
  update,
} from 'sdk/fspPayerFraudOverride';
import { ADD, IMPORT, LOAD, REMOVE, UPDATE } from 'model/fspPayerFraudOverride';
import {
  ADDED,
  IMPORTED,
  REMOVED,
  UPDATED,
  formatSuccessMessage,
} from 'consts';
import { takeEvery } from 'redux-saga/effects';
import { callAction, ORM } from '../util';
import { loadFSPProfileAction } from './export';

const keyName = { key: 'overridelist', name: 'Override' };

export const importOverrides = () =>
  callAction({
    api: importAndReset,
    dataName: ORM,
    formatSuccessMessage: formatSuccessMessage(keyName, IMPORTED, true),
    type: IMPORT,
  });

function* addAndPopulateExport(action) {
  const addAction = callAction({
    api: add,
    dataName: ORM,
    formatSuccessMessage: formatSuccessMessage(keyName, ADDED),
    type: ADD,
  });

  if (yield addAction(action)) {
    yield loadFSPProfileAction(action);
  }
}
function* importAndPopulateExport(action) {
  const importAndResetAction = importOverrides();

  if (yield importAndResetAction(action)) {
    yield loadFSPProfileAction(action);
  }
}
function* removeAndPopulateExport(action) {
  const removeAction = callAction({
    api: remove,
    dataName: ORM,
    formatSuccessMessage: formatSuccessMessage(keyName, REMOVED, true),
    type: REMOVE,
  });

  if (yield removeAction(action)) {
    yield loadFSPProfileAction(action);
  }
}
function* updateAndPopulateExport(action) {
  const updateAction = callAction({
    api: update,
    dataName: ORM,
    formatSuccessMessage: formatSuccessMessage(keyName, UPDATED),
    type: UPDATE,
  });

  if (yield updateAction(action)) {
    yield loadFSPProfileAction(action);
  }
}

export default function* saga() {
  yield takeEvery(
    LOAD.ACTION,
    callAction({
      api: load,
      dataName: ORM,
      type: LOAD,
    })
  );

  yield takeEvery(ADD.ACTION, addAndPopulateExport);

  yield takeEvery(IMPORT.ACTION, importAndPopulateExport);

  yield takeEvery(REMOVE.ACTION, removeAndPopulateExport);

  yield takeEvery(UPDATE.ACTION, updateAndPopulateExport);
}
